export const locale = {
  lang: 'it',
  data: {
    INVOICE: {
      UPLOAD_INVOICE: 'Caricamento fattura',
      EDIT_INVOICE: 'Modifica fattura',
      INVOICES: 'Fatture in Bozza',
      DEBTOR: 'Debitore',
      NUMBER_INVOICE: 'Numero fattura',
      AMOUNT: 'Importo',
      TOTAL: 'Totale',
      DUE_DATE: 'Data Scadenza',
      MINIMUM_BID: 'Importo Minimo',
      STATUS: 'Stato',
      REFRESH: 'Aggiorna',
      NEW: 'Carica fattura Extra Ue o Bucket',
      XML: 'CARICA FATTURA ELETTRONICA XML',
      UPLOAD_XML: 'Carica fatture XML',
      DROP_ZONE_LABEL: 'Trascina qui i file XML o clicca per caricare',
      STATUSES: {
        DRAFT: 'Bozza',
        SENT: 'Inviata',
      },
      EDIT: 'Modifica',
      ATTACH: 'Allegati',
      SEND: 'Invia',
      DELETE: 'Elimina',
      PUBLISH_DIALOG: {
        TITLE: 'Accetta le condizioni del servizio per pubblicare la fattura',
        DESCRIPTION: 'Accetta le condizioni di servizio',
        TOS_1: 'Confermo di conoscere e accetto i',
        TOS_1_LINK: '"Termini e Condizioni di Utilizzo della Piattaforma"',
        TOS_2: 'Confermo di conoscere e accetto le seguenti',
        TOS_2_LINK: '"Condizioni della Cessione"',
        CANCEL: 'Annulla',
        PUBLISH: 'Pubblica',
        SUCCESS: 'La fattura è stata inviata a CashMe ed è consultabile nella sezione "Fatture In lavorazione".',
      },
      ERROR_DIALOG: {
        TITLE: 'Attenzione',
        MESSAGE: 'Si è verificato un errore nell\'invio della fattura. Ricontrollare i seguenti dati:',
        MESSAGE_PROFILE: 'Per procedere con la pubblicazione della fattura, completa i dati mancanti nella sezione Profilo a sinistra',
      },
      DELETE_DIALOG: {
        TITLE: 'Conferma',
        DESCRIPTION: 'Vuoi eliminare questa fattura?',
        CANCEL: 'Annulla',
        OK: 'Conferma',
        SUCCESS: 'Fattura eliminata correttamente.',
      },
      SNACKBAR: {
        DEBTOR_ADDED: 'Cliente aggiunto con successo!',
        INVOICE_ADDED: 'Fattura aggiunta con successo!',
        INVOICE_EDITED: 'Fattura modificata con successo!',
        ADDED: 'Fattura aggiunta con successo!',
        DELETED: 'Fattura eliminata con successo!',
        NOT_DELETED: 'Errore: fattura non eliminata!',
        ATTACHMENT_ERROR: 'Errore caricamento file',
        ERROR: 'Errore: riprova!',
        ATTACHMENT: 'Devi caricare almeno una fattura elettronica XML e tutti i documenti obbligatori.',
        DUE_DATE: 'Devi inserire una data di scadenza successiva a domani',
        ACTIVATED: 'Devi essere abilitato dal team CashMe per poter pubblicare una fattura',
      },
      XML_OR_P7M_ONLY: 'Sono accettati solo file XML o P7M.',
    },
  },
};
